/*
 * Marketing API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.26
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';

/**
 * The CampaignIdTestBody model module.
 * @module model/CampaignIdTestBody
 * @version 1.0.0
 */
export class CampaignIdTestBody {
  /**
   * Constructs a new <code>CampaignIdTestBody</code>.
   * @alias module:model/CampaignIdTestBody
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>CampaignIdTestBody</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/CampaignIdTestBody} obj Optional instance to populate.
   * @return {module:model/CampaignIdTestBody} The populated <code>CampaignIdTestBody</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new CampaignIdTestBody();
      if (data.hasOwnProperty('segmentIds'))
        obj.segmentIds = ApiClient.convertToType(data['segmentIds'], ['String']);
    }
    return obj;
  }
}

/**
 * @member {Array.<String>} segmentIds
 */
CampaignIdTestBody.prototype.segmentIds = undefined;

